import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import collectionsStore from '../collectionsStore'

import { StoreExt } from '@utils/reactExt'

import { terms } from '@services/api'

export class termsStore extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable filteredList = []
    @observable filters = {}
    @observable pagination = {
        total: 0,
        page: 1
    }
    @observable editTerm = {}
    @observable editTermCollection = {}

    @action
    addTerm = term => {
        this.list = [term, ...this.list]
        this.editTerm = { ...term }
    }

    @action
    updateTerm = async collection_id => {
        await terms.updateTerm({ ...this.editTerm })
        await this.getTermsList(collection_id)
    }

    @action
    getFilteredList = async () => {
        this.loading = true
        const { list, total } = (await terms.getList({ ...this.filters, ...this.pagination })).data
        runInAction(() => {
            this.filteredList = list
            this.pagination.total = total
            this.loading = false
        })
    }

    @action
    getTermsList = async collection_id => {
        this.loading = true
        const { list, total } = (await terms.getList({ collection_id })).data
        runInAction(() => {
            this.list = list
            this.pagination.total = total
            this.loading = false
        })
    }

    @action
    changePage = page => {
        this.loading = true
        runInAction(() => {
            this.loading = false
            this.pagination.page = page
            this.getFilteredList()
        })
    }

    @action
    setFilter = (name, value) => {
        this.loading = true
        const currentFilters = { ...this.filters }
        runInAction(() => {
            this.loading = false
            this.filters = { ...currentFilters, [name]: value }
        })
    }

    @action
    toggleEdit = term => {
        if (term.id !== this.editTerm['id']) {
            this.editTerm = { ...term }
        } else {
            this.editTerm = {}
        }
    }

    @action
    setEditTerm = term => {
        this.editTerm = { ...term }
    }

    @action
    changeValue = (name, value) => {
        this.editTerm[name] = value
    }

    @action
    deleteFromCollection = async (collection_id, policies) => {
        await terms.deleteFromCollection({ collection_id, term_id: this.editTerm['id'], policies })
        this.getTermsList(collection_id)
        collectionsStore.getCollection(
            window.location.href.slice(window.location.href.split('/', 4).join('/').length + 1)
        )
    }

    @action
    resetPagingation = () => {
        this.pagination = {
            page: 1,
            total: 0
        }
    }

    @action
    resetFilters = () => {
        this.filters = {}
        this.resetPagingation()
        this.getFilteredList()
    }

    @action
    resetEdit = () => {
        this.editTerm = {}
    }
}

export default remotedev(new termsStore())
